document.addEventListener("DOMContentLoaded", () => {
    const faqContainer = document.querySelector(".questions");

    faqContainer.addEventListener("click", (e) => {
        const header = e.target.closest(".card-header");
        if (!header) return;

        const index = header.id.replace("faqHeading-", "");
        const body = document.getElementById(`faqCollapse-${index}`);

        faqContainer.querySelectorAll(".collapse-faq.show").forEach((el) => {
            if (el !== body) {
                el.style.maxHeight = el.scrollHeight + "px";
                requestAnimationFrame(() => {
                    el.style.maxHeight = "0";
                });
                el.classList.remove("show");
                el.previousElementSibling.setAttribute("aria-expanded", false);
            }
        });

        if (body.classList.contains("show")) {
            body.style.maxHeight = body.scrollHeight + "px";
            requestAnimationFrame(() => {
                body.style.maxHeight = "0";
            });
            body.classList.remove("show");
        } else {
            body.classList.add("show");
            body.style.maxHeight = body.scrollHeight + "px";

            body.addEventListener("transitionend", function handler() {
                if (body.classList.contains("show")) {
                    body.style.maxHeight = "none";
                }
                body.removeEventListener("transitionend", handler);
            });
        }

        header.setAttribute("aria-expanded", body.classList.contains("show"));
    });
});
